import type { FC } from "react";

import type { IImageLoader } from "@Components/ImageLoader";
import ImageLoader from "@Components/ImageLoader";

import IconWithBalloon, { IconWithBalloonPosition } from "./IconWithBalloon";

import * as css from "./CreditCardInfo.module.css";

export interface ICreditCardInfo {
    icon: IImageLoader;
    title: string;
    description: string;
    extraInfo?: string;
}

export const CreditCardInfo: FC<ICreditCardInfo> = ({ icon, title, description, extraInfo }) => (
    <div className={css.creditCardInfoComponent}>
        <ImageLoader {...icon} className={css.iconBank} />
        <div className={css.descriptionBank}>
            {title && <span>{title}</span>}
            {description && <span className={css.description}>{description}</span>}
        </div>
        {extraInfo && <IconWithBalloon message={extraInfo} position={IconWithBalloonPosition.TopLeft} />}
    </div>
);
